module.exports = __webpack_public_path__ + "img/no-product.5c4f36be.png";